import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { ListPrice } from 'src/app/shared/models/ListPrice';
import { PriceListInt } from 'src/app/shared/models/PriceList';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: 'app-price-list-int',
  templateUrl: './price-list-int.component.html',
  styleUrls: ['./price-list-int.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class PriceListIntComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;
  datePipe: DatePipe = new DatePipe('en-US');


  /** LABELS */
  translations: Record<string, string> = {};
  failedMsg: string;

  /** COMPONENT */
  priceListInt: PriceListInt[];
  clonedPriceList: { [s: string]: PriceListInt; } = {};
  orderId: string; // IDENTIFICADOR UNICO PARA RELOAD
  responseFile?: ResponseFile;
  isMonthAvailable: boolean = false;
  monthsMessage: string = "";

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** LANGUAJE FORM */
  dataForm: FormGroup;
  languagesLst: ValuesVO[];
  priceLst: ListPrice[];

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointPriceListByLang = "getFindAllByLanguage";
  endPointPriceListSelected = "getCategoryById";
  endPointPriceExchangeRate = "findMaxExchangeRate";

  endPointCreatePriceListInt = "createPriceListInt";
  endPointUpdatePriceListInt = "updatePriceListInt";
  endPointGetByIdPriceListInt = "getPriceListIntById";

  endPointUpdatePriceListIntH = "updatePriceListIntH";
  endPointCreatePriceListIntH = "createPriceListInth";
  endPoinGetByIdPriceListIntH = "getPriceListIntHById";
  endPoinUpdateCategory = "updateCategory";
  endPointClonePriceListById = "clonePriceListById";

  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private filesService: TovpilFilesService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private translationService: TovpilLanguageService,
    private tovpilUtils: TovpilUtilsService) {

    this.dataForm = this.fb.group({
      data_language: [null],
      data_list_id: [null],
      data_current_list: new FormControl({ value: null, disabled: true }),
      data_exchange_rate: new FormControl({ value: null, disabled: true }),
      data_status: new FormControl({ value: null, disabled: true }),
      token: [null],
      device: [null],
      storeId: [null],
    });


    this.route.queryParams.subscribe(
      params => {
        this.dataForm.patchValue({
          token: params.token,
          device: params.device,
          storeId: params.storeId,
        });
      });

    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            this.messageService.add({ severity: 'warn', summary: 'Authentication', detail: `Error: ${this.translations.lbl_login}, ${this.translations.lbl_then_try_it_again}` });
            // Autenticacion
          }
        },
        error => {
          this.messageService.add({ severity: 'warn', summary: 'Authentication', detail: `Error: ${this.translations.lbl_login}, ${this.translations.lbl_then_try_it_again}` });
          // Autenticacion
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.getPropertiesValue();
          this.security = data;
          this.getTranslatedLabels();
        });
    } else {
      this.getTranslatedLabels();
    }
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * `getLanguages`.
   */
  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(this.security.language, this.security.region);
      this.translations = this.translationService.getLabels();
      this.failedMsg = this.translations.lbl_internal_server_error;
      await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }

  /**
   * The function `getLanguages` is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    //console.debug("Debug: Languages     ");
    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, {
        "language": this.security!.language || null,
        "storeId": this.dataForm.get('storeId').value != null ? this.dataForm.get('storeId').value : this.security!.storeId ?? "0000000002"
      });

      if (result.success) {
        this.languagesLst = result.data;
        if (this.security.language) {
          this.dataForm.patchValue({
            data_language: this.languagesLst.find(o => o.valueId == this.security.language)
          });
          await this.getListPrice();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_language, detail: `Error: ${this.translations.lbl_search} ${this.translations.lbl_language}` });
        // Error al extraer lenguajes
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_language, detail: `Error: ${this.translations.lbl_search} ${this.translations.lbl_language}` });
      // Error al extraer lenguajes
    }
  }

  /**
   * The function `reloadData` is used to reload data by calling the `getListPrice` function and logging
   * a debug message.
   */
  reloadData() {
    //console.debug("Debug: Reloading     ");
    this.getListPrice();
  }

  /**
   * The `getListPrice` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getListPrice() {
    try {
      const resultList = await this.tovpilCrudService.fetch(this.endPointPriceListByLang, {
        "language": this.dataForm.get("data_language").value != null ? (this.dataForm.get("data_language").value).valueId : this.security?.language
      });

      const resultSelected = await this.tovpilCrudService.fetch(this.endPointPriceListSelected, {
        "fieldId": "curIntPrcL",
        "fieldVal": "selected" + (this.dataForm.get("data_language").value != null ? (this.dataForm.get("data_language").value).valueId : this.security?.language)
      });

      const resultExchangeRate = await this.tovpilCrudService.fetch(this.endPointPriceExchangeRate, {
        "exchDate": this.tovpilUtils.dateToTovpilDate(new Date()),
        "fromCurr": "MXN",
        "toCurr": "USD"
      });

      if (resultList.success && resultSelected.success && resultExchangeRate.success) {
        let data = resultList['data'];
        let selected = resultSelected['data']['descrip'];
        let exchangeRate = resultExchangeRate['data']['rate'];

        this.priceLst = data.map((divition: any) => {
          return {
            ...divition,
            label: divition.listId + ' ' + divition.currDate
          }
        });
        // Validamos que si esta una opcion seleccionada marque esa sino la busque (default)
        const selectedPrice = this.priceLst.find(p => p.listId == selected);
        this.dataForm.patchValue({
          data_current_list: selectedPrice ? selectedPrice.label : 'S/N',
          data_list_id: this.priceLst.find(p => p.listId == selected),
          data_exchange_rate: exchangeRate
        });

        this.dataForm.patchValue({
          data_status: (this.dataForm.get("data_list_id").value).status,
        });


        //console.debug("1. Debug: Data List     : ", this.priceLst);
        //console.debug("2. Debug: Data Selected : ", this.dataForm.get("data_list_id").value, " - ", this.dataForm.get("data_status").value);

        await this.loadData();

      } else {
        console.error("An error occurred while fetching price list:", resultList);
        this.dataForm.patchValue({
          data_language: this.languagesLst.find(o => o.valueId == this.security.language)
        });
        this.reloadData();
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_price_list, detail: `Error: ${this.translations.lbl_search} ${this.translations.lbl_price_list}` });
        // Error al extraer la lista de precios
      }
    } catch (error) {
      this.dataForm.patchValue({
        data_language: this.languagesLst.find(o => o.valueId == this.security.language)
      });
      this.reloadData();

      console.error("An error occurred while fetching price list:", error);
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_price_list, detail: `Error: ${this.translations.lbl_search} ${this.translations.lbl_price_list}` });
      // Error al extraer la lista de precios
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {
    if (!this.dataForm.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_record_not_valid,
        detail: `${this.translations.lbl_record_not_valid}, ${this.translations.lbl_entry_required_fields_and_pres}`,
        life: 5000
      });
      // Datos invalidos
      return;
    }

    this.blocked = true;
    try {
      const params = {
        "listId": (this.dataForm.get('data_list_id').value).listId,
        "language": (this.dataForm.get("data_language").value != null ? (this.dataForm.get("data_language").value).valueId : this.security?.language)
      };


      this.dataForm.patchValue({
        data_status: (this.dataForm.get("data_list_id").value).status,
      });

      //console.debug("3. Debug: Load Data     : ", params);
      this.priceListInt = await this.apiService.getListPriceInt(params);;
      this.priceListInt = this.priceListInt.map((division: PriceListInt) => {
        const { usdPrice } = division.prc || {};
        return {
          ...division,
          prc: {
            ...division.prc,
            usdPrice: usdPrice !== undefined ? usdPrice : 0,
            lastPrice: usdPrice !== undefined ? usdPrice : 0,
          }
        };
      });

      //console.debug("4. Debug: Real Data     : ", this.priceListInt);

    } catch (error) {
      console.error(error);
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_international_price_list,
        detail: `${this.failedMsg}: ${error}`
      });
      // Cancelacion de carga de datos
    } finally {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    }
  }

  /**
   * The function `aproveData` displays a confirmation dialog and performs certain actions based on the
   * user's response.
   */
  async aproveData() {
    this.confirmationService.confirm({
      message: `¿${this.translations.lbl_are_you_sure}?`,
      header: this.translations.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translations.lbl_approve,
      rejectLabel: this.translations.lbl_back,
      accept: async () => {
        const resultUpdate = await this.tovpilCrudService.fetch(this.endPointUpdatePriceListIntH, {
          "listId": (this.dataForm.get("data_list_id").value).listId,
          "currDate": this.tovpilUtils.dateToTovpilDate(new Date()),
          "language": this.security.language,
          "status": "A",
        });
        if (resultUpdate.success) {
          this.reloadData();
          // this.messageService.add({ severity: 'success', summary: `${this.translations.lbl_approve} ${this.translations.lbl_list} ${this.translations.lbl_international}`, detail: Constants.SUCCESS_MESSAGE, life: 3000 });
          // Cargado exitosamente
        } else {
          this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_approve} ${this.translations.lbl_list} ${this.translations.lbl_international}`, detail: this.failedMsg, life: 3000 });
          // Error al aprobar la lista
        }
      }, reject: () => {
        this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_approve} ${this.translations.lbl_list} ${this.translations.lbl_international}`, detail: this.failedMsg, life: 3000 });
        // Error al aprobar la lista
      }
    });
  }

  /**
   * The `createData` function prompts the user for confirmation, and if accepted, formats the order
   * details and logs a success message.
   */
  async createData() {
    this.confirmationService.confirm({
      message: `¿${this.translations.lbl_are_you_sure}?`,
      header: this.translations.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translations.lbl_validate,
      rejectLabel: this.translations.lbl_back,
      accept: async () => {
        this.blocked = true;
        const result = await this.tovpilCrudService.fetch(this.endPointClonePriceListById, {
          "language": (this.dataForm.get("data_language").value).valueId,
          "listId": (this.dataForm.get("data_list_id").value).listId
        });

        const severity = result.success ? 'success' : 'warn';
        const detailMessage = result.success ? Constants.SUCCESS_MESSAGE : this.failedMsg;

        // Creacion de lista internacional
        if (severity == 'success') {
          // const result2 = await this.tovpilCrudService.fetch(this.endPoinUpdateCategory, {
          //   "id": { "fieldId": "curIntPrcL", "fieldVal": "selected" + result['data']['language'] },
          //   "descrip": result['data']['listId']
          // });
          this.reloadData();
        }
        else {
          this.messageService.add({ severity, summary: `${this.translations.lbl_new} ${this.translations.lbl_list} ${this.translations.lbl_international}`, detail: detailMessage, life: 3000 });
        }
        this.blocked = false;
      }, reject: () => {
        // this.messageService.add({ severity: 'warn', summary: this.translations.lbl_items_management_Int, detail: 'Se canceló correctamente' });
        // Se cancelo correctamente
      }
    });
  }

  /**
   * The `selectUpToDateData` function is an asynchronous function that confirms the selection of a list
   * as up-to-date and performs various API calls and updates based on the result.
   */
  async selectUpToDateData() {
    try {
      await this.confirmationService.confirm({
        message: `¿${this.translations.lbl_are_you_sure}?`,
        header: this.translations.lbl_confirm,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.translations.lbl_select,
        rejectLabel: this.translations.lbl_back,
        accept: async () => {
          const resultUpdate = await this.tovpilCrudService.fetch(this.endPoinGetByIdPriceListIntH, {
            "listId": (this.dataForm.get("data_list_id").value).listId,
          });

          let catk = { "fieldId": "curIntPrcL", "fieldVal": "selected" + this.security.language };

          if (!resultUpdate.success) {
            this.messageService.add({ severity: 'warn', summary: `Error: ${this.translations.lbl_list} ${this.translations.lbl_international}`, detail: this.failedMsg, life: 3000 });
            // Error al aprobar la lista
            return;
          }

          const cat = await this.tovpilCrudService.fetch(this.endPointPriceListSelected, catk);

          // UPDATE | CREATE
          const id = cat.success ? cat.data?.id : catk;

          const result = await this.tovpilCrudService.fetch(this.endPoinUpdateCategory, {
            "id": id,
            "descrip": cat.success ? (this.dataForm.get("data_list_id").value).listId : "selected" + this.security.language
          });

          const severity = result.success ? 'success' : 'warn';
          const detailMessage = severity === 'warn' ? this.failedMsg : Constants.SUCCESS_MESSAGE;

          this.messageService.add({
            severity: severity,
            summary: 'Seleccionar Lista Internacional',
            detail: detailMessage,
            life: 3000
          });

          if (result.success) {
            this.updatePriceListH(result['data']['descrip']);
          }
        },
        reject: () => {
          this.messageService.add({ severity: 'warn', summary: `Error: ${this.translations.lbl_list} ${this.translations.lbl_international}`, detail: this.failedMsg, life: 3000 });
        }
      });
    } catch (error) {
      console.error('An error occurred:', error);
      this.messageService.add({ severity: 'warn', summary: `Error: ${this.translations.lbl_list} ${this.translations.lbl_international}`, detail: `${this.failedMsg}: ${error}`, life: 3000 });
    }
  }

  /**
   * The function `updatePriceListH` is an asynchronous function that updates a price list based on the
   * provided list ID.
   * @param {any} _listId - The _listId parameter is the ID of the price list that needs to be updated.
   * @returns The function does not have a return statement.
   */
  async updatePriceListH(_listId: any) {
    try {
      const resultSearch = await this.tovpilCrudService.fetch(this.endPoinGetByIdPriceListIntH, {
        "listId": _listId,
      });

      if (!resultSearch.success) {
        return;
      }

      const { listId, language, status } = resultSearch.data;
      const currDate = this.tovpilUtils.dateToTovpilDate(new Date());

      const resultUpdate = await this.tovpilCrudService.fetch(this.endPointUpdatePriceListIntH, {
        "listId": listId,
        "currDate": currDate,
        "language": language,
        "status": status,
      });

      const severity = resultUpdate.success ? 'success' : 'warn';
      // const detailMessage = resultUpdate.success ? Constants.SUCCESS_MESSAGE : Constants.FAILED_MESSAGE;

      // this.messageService.add({ severity, summary: 'Aprobación Lista Internacional', detail: detailMessage, life: 3000 });
      this.reloadData();
    } catch (error) {
      console.error('An error occurred:', error);
      this.messageService.add({ severity: 'warn', summary: `Error: ${this.translations.lbl_list} ${this.translations.lbl_international}`, detail: `${this.translations.lbl_internal_server_error}: ${this.failedMsg}`, life: 3000 });
    }
  }



  /**
   * The function `saveUpdatePriceItem` updates or creates an order in the price list table based on the
   * provided `order` object.
   * @param {PriceList} order - The parameter "order" is of type "PriceList".
   */
  async saveUpdatePriceItem(order: PriceListInt, index: number) {
    try {
      const data_list_id = this.dataForm.get("data_list_id").value;
      const { listId } = data_list_id;

      const plk = {
        listId,
        itemId: order.itemId,
        language: this.security.language
      };

      const resultPriceList = await this.tovpilCrudService.fetch(this.endPointGetByIdPriceListInt, plk);
      const data = !(resultPriceList && resultPriceList.success && resultPriceList.data) ? plk : resultPriceList.data.id;

      const updateData = {
        id: data,
        usdPrice: parseFloat(order?.prc?.usdPrice + "") ?? 0
      };

      const endpoint = order.prc.id ? this.endPointUpdatePriceListInt : this.endPointCreatePriceListInt;
      const resultPriceListUpdate = await this.tovpilCrudService.fetch(endpoint, updateData);

      let res = this.handleResultMessage(resultPriceListUpdate, data.id ? 'Actualizar precio' : 'Creación precio');
      if (res) {
        this.reloadData();
      } else {
        this.onRowEditCancel(order, index);
      }
    } catch (error) {
      console.error(error);
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_update} ${this.translations.lbl_price}`, detail: `${this.failedMsg}: ${error}` });
    }
  }

  /**
   * The function "handleResultMessage" adds a message to the message service based on the result of an
   * action.
   * @param {any} result - The `result` parameter is an object that contains the result of an action. It
   * is expected to have a `success` property that indicates whether the action was successful or not.
   * @param {string} action - The `action` parameter is a string that represents the action being
   * performed. It is used as the summary of the message that will be displayed.
   */
  private handleResultMessage(result: any, action: string) {
    const messageType = result.success ? 'success' : 'warn';
    this.messageService.add({ severity: messageType, summary: action, detail: messageType == 'success' ? Constants.SUCCESS_MESSAGE : Constants.FAILED_MESSAGE });
    if (result.success) {
      return true;
    }
    else {
      return false;
    }

  }

  /**
   * The function "onRowEditInit" is used to initialize the editing of a row in a price list.
   * @param {PriceList} order - The parameter "order" is of type "PriceList".
   */
  onRowEditInit(order: PriceListInt) {
    this.clonedPriceList[order.prc.id.listId + order.prc.id.itemId] = this.tovpilUtils.deepClone(order);
  }

  /**
   * The function onRowEditCancel takes in an order and an index as parameters and does nothing.
   * @param {PriceList} order - PriceList - The object representing the order that was being edited.
   * @param {number} index - The index parameter is a number that represents the index of the row being
   * edited in a list or array.
   */
  onRowEditCancel(order: PriceListInt, index: number) {
    this.priceListInt[index] = this.clonedPriceList[order.prc.id.listId + order.prc.id.itemId]
    delete this.clonedPriceList[order.prc.id.listId + order.prc.id.itemId]
  }

  /**
   * The `exportExcel()` function exports a filtered JSON data to an Excel file.
   */
  exportExcel() {
    if (this.priceListInt === null) {
      // Lista no existe
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else if (this.priceListInt.length < 1) {
      // Lista Vacia
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else {
      const filteredJSON = this.priceListInt.map((item) => ({
        "ID_ARTICULO": item ? (item?.itemId || 'S/N') : 'S/N',
        "DESCRIPCION": item ? (item?.descri || 'S/N') : 'S/N',
        "PRECIO_ULTIMA_COMPRA_MXN": item ? (item?.lastPOPrice || 'S/N') : 'S/N',
        "CONVERTIDO": item ? (item?.usdLastPOPrice || 'S/N') : 'S/N',
        "PRECIO_USD": item ? (item?.prc?.usdPrice || 'S/N') : 'S/N',
        "COSTO_PROMEDIO": item ? (item?.avgCost || 'S/N') : 'S/N',
      }));
      this.filesService.tovpilExportXLSX(filteredJSON, 'priceListInt_');
    }
  }

  /**
   * The exportPdf function exports a price list to a PDF file.
   */
  exportPdf() {
    if (this.priceListInt === null) {
      // Error de lista no existe
      this.messageService.add({ severity: 'error', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else if (this.priceListInt.length < 1) {
      // Error de lista vacía
      this.messageService.add({ severity: 'error', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else {
      const filteredJSON = this.priceListInt.map((item) => ({
        "ID_ARTICULO": item ? (item?.itemId || 'S/N') : 'S/N',
        "DESCRIPCION": item ? (item?.descri || 'S/N') : 'S/N',
        "PRECIO_ULTIMA_COMPRA_MXN": item ? (item?.lastPOPrice || 'S/N') : 'S/N',
        "CONVERTIDO": item ? (item?.usdLastPOPrice || 'S/N') : 'S/N',
        "PRECIO_USD": item ? (item?.prc?.usdPrice || 'S/N') : 'S/N',
        "COSTO_PROMEDIO": item ? (item?.avgCost || 'S/N') : 'S/N',
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'priceListInt_');
    }
  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    window.close();
  }
  onClickDownloadFile() {
    try {
      this.apiService.dwdCurrentPriceList(
        {
          "userId": this.security.userId,
          "language": this.dataForm.get("data_language").value != null ? (this.dataForm.get("data_language").value).valueId : this.security?.language
        }
      ).then(
        data => {
          this.responseFile = data;

          const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;


          const link = document.createElement("a");
          link.href = source;
          //link.download = `${(this.item != null ? this.item.descri : "") + '_' + (this.itemsAlbum != null ? this.itemsAlbum.name : "") + '_' + itm.id.sequence + " " + itm.name + "." + this.item.sellUM}`
          link.download = this.responseFile.nameFile
          link.click();


        })
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}: ${error}` });
    }
  }

  async getPropertiesValue() {
    let res: string = await this.apiService.getPropertyValue({
      "id": "pricelist.available.months"
    });

    if (res != null) {
      const month = new Date().getMonth() + 1;
      const monthString = month.toString().padStart(2, '0');
      if (res.includes(monthString)) {
        this.isMonthAvailable = true;
      } else {
        this.isMonthAvailable = false;
      }
      let months = this.obtainMonthsNames(res, this.security.language);
      this.monthsMessage = 'La lista de precios solo puede ser modificada en los meses: ' + months;
    }
    else {
      this.isMonthAvailable = true;
      this.monthsMessage = 'Var is null';
    }
  }

  obtainMonthsNames(meses: string, lenguaje: string = 'es'): string {
    const mesesArray = meses.split(',').map(m => parseInt(m.trim(), 10) - 1); // 0-based
    const nombres = mesesArray.map(mes => {
      const fecha = new Date(2000, mes); // Fecha ficticia
      return fecha.toLocaleString(lenguaje, { month: 'long' });
    });

    return nombres.join(', ');
  }
}